(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-toro-product]').forEach((product) => {
      if (product.dataset.commerceReady) return;
      product.dataset.commerceReady = 'true';
      const select = product.querySelector('[data-variant-select]');
      const quantity = product.querySelector('[data-product-quantity]');
      const add = product.querySelector('[data-add-to-cart]');
      const requiresPlan = add.dataset.requiresPlan === 'true';
      const mediaItems = [...product.querySelectorAll('[data-product-media]')];
      const mediaLinks = [...product.querySelectorAll('[data-media-link]')];

      const showMedia = (id) => {
        if (!mediaItems.some((item) => item.dataset.productMedia === id)) return;
        mediaItems.forEach((item) => {
          item.hidden = item.dataset.productMedia !== id;
          if (item.hidden) {
            item.querySelectorAll('video').forEach((video) => video.pause());
            // Detach hidden embeds to stop playback without a third-party player API.
            item.querySelectorAll('iframe').forEach((frame) => {
              if (frame.hasAttribute('src')) {
                frame.dataset.embedSrc = frame.getAttribute('src');
                frame.removeAttribute('src');
              }
            });
          } else {
            item.querySelectorAll('iframe[data-embed-src]').forEach((frame) => {
              frame.setAttribute('src', frame.dataset.embedSrc);
              delete frame.dataset.embedSrc;
            });
          }
        });
        mediaLinks.forEach((link) => {
          if (link.dataset.mediaLink === id) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };

      const updateVariant = (updateUrl) => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const data = option.dataset;
        product.querySelector('[data-product-price]').textContent = data.price;
        const compare = product.querySelector('[data-compare-price]');
        compare.textContent = data.compare;
        compare.hidden = !data.compare;
        const discount = product.querySelector('[data-discount]');
        discount.textContent = `${data.discount}% OFF`;
        discount.hidden = Number(data.discount) <= 0;
        const available = data.available === 'true';
        product.querySelector('[data-availability]').textContent = available ? 'Available' : 'Sold out';
        const sku = product.querySelector('[data-sku]');
        sku.textContent = `SKU: ${data.sku}`;
        sku.hidden = !data.sku;
        const unitPrice = product.querySelector('[data-unit-price]');
        unitPrice.textContent = data.unitPrice;
        unitPrice.hidden = !data.unitPrice;
        add.disabled = !available || requiresPlan;
        add.textContent = requiresPlan ? 'Purchase plan required' : available ? 'Add to cart' : 'Sold out';
        quantity.min = data.min;
        quantity.step = data.step;
        if (data.max) quantity.max = data.max;
        else quantity.removeAttribute('max');
        if (updateUrl) quantity.value = data.min;
        showMedia(data.media);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      };

      select.addEventListener('change', () => updateVariant(true));
      mediaLinks.forEach((link) => link.addEventListener('click', (event) => {
        event.preventDefault();
        showMedia(link.dataset.mediaLink);
      }));
      // The product form keeps its native POST, Shopify errors, and cart redirect.
      updateVariant(false);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) updateVariant(false);
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
